import { Option, Select } from "@admin/components/atoms/Input";
import { Label } from "@admin/components/atoms/Input/Label";
import { LocationLicensesDto, Module } from "@enos-monorepo/lib";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface ModuleSettingsProps {
  module: Module;
  options: Option[];
  setLicense: Dispatch<SetStateAction<LocationLicensesDto[]>>;
  companyId: string;
}

export default function ModuleSettings({
  module,
  options,
  setLicense,
  companyId,
}: ModuleSettingsProps) {
  const { t } = useTranslation();
  const [invoice, setInvocice] = useState<number>(0);

  useEffect(() => {
    setLicense((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.companyId === companyId && item.moduleId === module.id,
      );

      if (existingIndex === -1) {
        return [
          ...prev,
          {
            companyId: companyId,
            invoiceDate: invoice,
            moduleId: module.id,
          },
        ];
      }

      return prev.map((item, index) => {
        if (index === existingIndex) {
          return {
            ...item,
            invoiceDate: invoice,
          };
        }
        return item;
      });
    });
  }, [companyId, invoice, module.id, setLicense]);

  return (
    <div className="sr-only">
      <div className="border-b border-b-gray-200 my-2.5"></div>
      <h2>{module.name}</h2>
      <Label title={t("location.Monthly Accounting Day")}>
        <Select
          defaultValue={0}
          options={options}
          size="sm"
          onChange={(e) => {
            setInvocice(Number(e.target.value));
          }}
        />
      </Label>
    </div>
  );
}
